module.exports = __webpack_public_path__ + "media/cyberpunk-city.6f344c5e.mp4";